<template>
    <div class="d-flex flex-column">
        <span class="visually-hidden">{{ offerNameAccessibility }}</span>
        <ob1-boutons
            data-bs-toggle="modal"
            :data-bs-target="'#' + popinId"
            :is-primary="isPrimary"
            :is-secondary="!isPrimary"
            :label="label"
            :data-oevent-category="trackingCategory"
            :data-oevent-action="label"
            :data-oevent-label="trackingLabel"
        />

        <div class="row">
            <all-disponibilities-popin
                :id="popinId"
                :title="popinCtasDto.title"
                :tdc-section="popinCtasDto.tdcSection"
                :eresa-section="popinCtasDto.eresaSection"
                :eco-foot-note="popinCtasDto.ecoFootNote"
                :tdc-href="popinCtasDto.tdcSection.button.href"
                :eresa-href="popinCtasDto.eresaSection.button.href"
            />
        </div>
    </div>
</template>

<script>
import AllDisponibilitiesPopin from "../components/AllDisponibilitiesPopin.vue";

export default {
    name: "OfferCtaWithDeliveryPopin",
    components: {AllDisponibilitiesPopin},
    props: {
        label: {
            type: String,
            required: true
        },
        isPrimary: {
            type: Boolean,
            required: true
        },
        popinId: {
            type: String,
            required: true
        },
        popinCtasDto: {
            type: Object,
            required: true
        },
        advantageMessages: {
            type: Object,
            required: true
        },
        advantageValues: {
            type: Object,
            required: false,
            default: () => {}
        },
        isOnlineRecoveryAvailable: {
            type: Boolean,
            required: true
        },
        offerName: {
            type: String,
            required: true
        },
        trackingCategory: {
            type: String,
            required: true
        },
        trackingLabel: {
            type: String,
            required: true
        }
    },
    computed: {
        offerNameAccessibility() {
            return "Ajouter le nouveau forfait " + this.offerName;
        }
    }
}
</script>
